import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { AuthGate } from "../features/auth/AuthGate.jsx";
import { RecoveredApplication } from "./RecoveredApplication.jsx";

const k = { Fragment, jsx, jsxs };

export function App() {
  return (0, k.jsx)(AuthGate, { MainApplication: RecoveredApplication });
}
